import { httpsCallable } from 'firebase/functions';
import { auth, functions } from '../firebase';

const call = (name, data = {}) => httpsCallable(functions, name)(data).then((result) => result.data);

export const communityApi = {
  next: () => call('getNextCommunityReview'),
  submit: (answer) => call('submitCommunityReview', answer),
  undo: (review) => call('undoCommunityReview', review),
  admin: (options) => call('getCommunityReviewAdmin', options),
  resolve: (decision) => call('resolveCommunityReview', decision),
};

export const motionReviewApi = {
  highlights: (options) => call('getMotionHighlights', options),
  scope: () => auth?.currentUser?.uid,
  isActive: (scope) => auth?.currentUser?.uid === scope,
  buffer: (options) => call('getMotionReviewBuffer', options),
  progress: () => call('getNextMotionReview', { progressOnly: true }),
  leaderboard: () => call('getMotionReviewLeaderboard'),
  next: () => call('getNextMotionReview'),
  submit: (answer) => call('submitMotionReview', answer),
  undo: (review) => call('undoMotionReview', review),
  admin: (options) => call('getMotionReviewAdmin', options),
  adminStats: () => call('getMotionReviewAdmin', { statsOnly: true }),
  resolve: (decision) => call('resolveMotionReview', decision),
  dismissFlags: (track) => call('dismissMotionReviewFlags', track),
  sighting: (request) => call('motionReviewSighting', request),
};

export function readableError(error) {
  const messages = {
    'auth/email-already-in-use': 'An account already uses this email. Sign in or reset your password.',
    'auth/invalid-email': 'Please enter a valid email address.',
    'auth/weak-password': 'Please choose a password with at least 6 characters.',
    'auth/wrong-password': 'Your email or password did not match. Please try again.',
    'auth/user-not-found': 'Your email or password did not match. Please try again.',
    'auth/invalid-login-credentials': 'Your email or password did not match. Please try again.',
    'auth/invalid-credential': 'Your email or password did not match. Please try again.',
    'auth/too-many-requests': 'Too many attempts. Please wait a moment and try again.',
    'auth/network-request-failed': 'Check your connection, then try again.',
    'functions/unavailable': 'Check your connection, then try again. Your selection is still here.',
    'functions/deadline-exceeded': 'The request took too long. Please try again; your review will only count once.',
    'functions/unauthenticated': 'Please sign in again to continue.',
  };
  return messages[error?.code] || error?.message || 'Something went wrong. Please try again.';
}
